// extracted by mini-css-extract-plugin
export default {"guide":"WDRo","right":"yKtA","left":"GwYs","up":"B5lD","down":"yPnQ","space":"QkSt"};